import React from 'react';
import styled from 'styled-components/macro';
import { fontSize01, fontWeightBold } from '../../styling/fonts';
import { spacing01, spacing02 } from '../../styling/spacing';
import { FieldErrorIndicator } from './FieldErrorIndicator';

export const labelContainerTestId = 'label-container';
export const fieldLabelErroredTestId = 'field-label-errored';

type Props = {
  label: string | React.ReactNode;
  labelIcon?: React.ReactNode;
  fieldName: string;
  showError: boolean;
  error: string | null;
  className?: string;
};

export const FieldLabel = ({ label, labelIcon, fieldName, showError, error, className }: Props) => {
  return (
    <Container className={className} data-testid={showError ? fieldLabelErroredTestId : undefined}>
      <StyledLabel data-testid={labelContainerTestId} htmlFor={fieldName}>
        {label}
      </StyledLabel>
      {labelIcon != null && <LabelIconContainer>{labelIcon}</LabelIconContainer>}
      <ErrorIndicator fieldName={fieldName} showError={showError} error={error} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${spacing02};
  height: 20px;
`;

export const labelStyles = `
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: ${fontSize01};
  font-weight: ${fontWeightBold};
`;

export const StyledLabel = styled.label`
  display: block;
  ${labelStyles}
`;

const ErrorIndicator = styled(FieldErrorIndicator)`
  margin: 0 ${spacing01};
`;

const LabelIconContainer = styled.div`
  cursor: pointer;

  height: 20px;
  width: 20px;
  min-height: 20px;
  min-width: 20px;

  margin: 0 ${spacing01};

  svg {
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
  }
`;
